/**
 * NavCell — one cell of the locked segmented nav control, shared by the three
 * nav surfaces (league top nav, team top nav, bottom nav). Icon (line icon) over
 * an 800-weight label, with an inset 2px active rail (underline for the top navs,
 * top rail for the bottom nav). All visual tokens come from navTheme; the active
 * accent is the themeable var(--team-primary).
 *
 * Presentation only — `onClick` is passed straight through; active state is
 * derived by the parent from the current route (unchanged behavior).
 */
import React from 'react';
import { navTheme } from '../../../services/mobileNavTheme';

const NavCell = ({ Icon, label, isActive, onClick, cell, divider = false, style = {} }) => {
  const color = isActive ? navTheme.primary : navTheme.inactive;
  return (
    <button
      type="button"
      onClick={onClick}
      aria-current={isActive ? 'page' : undefined}
      data-active={isActive ? 'true' : 'false'}
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: cell.gap,
        padding: '7px 0',
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        color,
        whiteSpace: 'nowrap',
        WebkitTapHighlightColor: 'transparent',
        ...(divider ? { borderLeft: navTheme.cellDivider } : {}),
        ...style,
      }}
    >
      {isActive && (
        <span
          aria-hidden="true"
          style={{
            position: 'absolute',
            left: cell.railInset,
            right: cell.railInset,
            [cell.railPosition]: 0,
            height: '2px',
            borderRadius: '2px',
            background: navTheme.primary,
          }}
        />
      )}
      {Icon && <Icon size={cell.iconSize} strokeWidth={navTheme.iconStroke} color={color} aria-hidden="true" />}
      <span style={{ fontSize: cell.labelSize, fontWeight: cell.labelWeight, lineHeight: 1 }}>{label}</span>
    </button>
  );
};

export default NavCell;
